import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
import { META_PIXEL_ID } from './utils/tracking';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showTestimonials = true,
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white text-slate-700" data-id="element-0" data-mp="d2bibguajxvo">
      <main data-id="element-1" data-mp="86w3omoglxy7">
        <Hero data-id="element-2" data-mp="86cmj86mvdl8" />
        <ProductGallery data-id="element-3" data-mp="83qgxe3az85n" />
        {showTestimonials && <TestimonialsStrip data-id="element-4" data-mp="3gkl6jrv3aw1s" />}
        <PainPoints data-id="element-5" data-mp="3glwfs77b0w0a" />
        <SolutionReveal data-id="element-6" data-mp="3gj1ru5p30t24" />
        <VolumesSection data-id="element-7" data-mp="3bmjnv81ksyqu" />
        <BonusSection data-id="element-8" data-mp="3bncorsdusu12" />
        <PricingSection data-id="element-9" data-mp="3bo4lx7n3mztg" />
        <ClosingArgument data-id="element-10" data-mp="3bkguce17snhd" />
        <Guarantee data-id="element-11" data-mp="3qbpql5zmh73h" />
        <FAQ data-id="element-12" data-mp="3qc948ai8p9bp" />
        <FinalCTA data-id="element-13" data-mp="3qcqyj1lcddgz" />
      </main>
      <Footer data-id="element-14" data-mp="3qd0ud5t2ieul" />
      {showPurchaseNotifications && <PurchaseNotification data-id="element-15" data-mp="3ljg11r2f691q" />}
      <noscript data-id="element-16" data-mp="3lj6bu5p785x3">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-17" data-mp="3limq0dwfgxds" />
      </noscript>
    </div>;
}